import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=325e7b1d&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=325e7b1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e7b1d",
  null
  
)

export default component.exports